import { Link } from 'react-router';
import type { FieldTestBrief, FieldTestStatus } from '../api/client';
import { monthDay, type Tone } from '../lib/format';
import { Chip, Notice } from './ui';

/**
 * Field tests where the risky buttons are (1.13.0, Teampace 3124, proposal 107): before Bring every
 * customer up to date, turning on Live sessions or running Number inventory, Stitch Admin → Updates
 * names the field tests that check it and each one's newest result. It warns; it never blocks.
 */

const WORDS: Record<FieldTestStatus, { label: string; tone: Tone }> = {
  passed: { label: 'Passed', tone: 'ok' },
  failed: { label: 'Failed', tone: 'crit' },
  blocked: { label: 'Couldn’t try', tone: 'warn' },
  skipped: { label: 'Skipped', tone: 'neutral' },
  not_run: { label: 'Not run yet', tone: 'warn' }
};

/** "Passed Nov 20", "Not run yet", "Needs Stitch 1.13.0". */
export function briefResult(t: FieldTestBrief): { label: string; tone: Tone } {
  if (t.status === 'not_run' || !t.testedAt) return t.ready ? WORDS.not_run : { label: `Needs Stitch ${t.needs}`, tone: 'neutral' };
  const w = WORDS[t.status];
  return { label: `${w.label} ${monthDay(t.testedAt)}`, tone: w.tone };
}

export function FieldTestReminder({ tests, what }: { tests: FieldTestBrief[] | undefined; what: string }) {
  if (!tests?.length) return null;
  const passed = tests.every((t) => t.status === 'passed');
  return (
    <Notice tone={passed ? 'ok' : 'warn'} title={passed ? `Field tests for ${what}: passed` : `Field tests for ${what}`}>
      <ul className="plain-list field-test-reminder" aria-label={`Field tests for ${what}`}>
        {tests.map((t) => {
          const r = briefResult(t);
          return (
            <li key={t.id}>
              <Link to={`/admin/field-tests?test=${encodeURIComponent(t.id)}`}>{t.title}</Link>{' '}
              <Chip small tone={r.tone}>
                {r.label}
              </Chip>
            </li>
          );
        })}
      </ul>
      {!passed && <small className="muted">You can still go ahead. These check on real phones what this changes; run them, or run them again, once it’s done.</small>}
    </Notice>
  );
}
